import React from 'react';
import _ from 'lodash';
import { useConnect } from '@lore/query-connect';
import { PayloadStates } from '@lore/utils';
import REQUIRED_FIELDS from '../../offers/REQUIRED_FIELDS';
import ChartLoader from '../../dashboard/_charts/ChartLoader';
import LegendChart from '../../dashboard/_charts/LegendChart';

export default function OfferActivityYear(props) {
  const { network, schoolStart, schoolEnd, subtitle, activities } = props;

  const allOffers = useConnect('offer.find', {
    where: {
      eager: {
        $where: {
          $and: REQUIRED_FIELDS.$and,
          createdAt: {
            $lte: schoolEnd,
            $gte: schoolStart
          },
          networkId: network?.id
        }
      }
    },
    pagination: {
      pageSize: 1
    }
  });

  const requests = _.sortBy(activities.data, at => at.data.name).map(function(activity) {
    return {
      label: activity.data.name,
      offers: useConnect('offer.find', {
        where: {
          eager: {
            $where: {
              $and: REQUIRED_FIELDS.$and,
              activityId: activity.id,
              createdAt: {
                $lte: schoolEnd,
                $gte: schoolStart
              },
              networkId: network?.id
            }
          }
        },
        pagination: {
          pageSize: 1
        }
      })
    };
  });

  const loading = _.reduce(requests, function(result, request) {
    return result || request.offers.state === PayloadStates.FETCHING;
  }, false)

  if (loading || allOffers.state === PayloadStates.FETCHING) {
    return (
      <ChartLoader
        title="Offers by Activity"
        subtitle={subtitle || 'For school year'}
      />
    );
  }

  const sortedRequests = _.sortBy(requests, r => -r.offers.meta.totalCount);

  const series = sortedRequests.map(r => r.offers.meta.totalCount);
  const labels = sortedRequests.map(r => r.label);

  return (
    <LegendChart
      title="Offers by Activity"
      subtitle={subtitle || 'For school year'}
      labels={labels}
      series={series}
    />
  );
}
